import { render, staticRenderFns } from "./LASA.vue?vue&type=template&id=6c23b68a&"
import script from "./LASA.vue?vue&type=script&lang=js&"
export * from "./LASA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports